import {Injectable} from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class AccountGuard  {
  constructor(
    private auth: AuthService,
    private route: Router,
  ) {}

  public async canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isAuth = await this.auth.isAuthenticatedAsync();

    if (!isAuth) {
      const queryParams = state.url === '/home' ? {} : { queryParams: { returnurl: state.url === "/" ? null : state.url } };
      this.route.navigate(['login'], queryParams);
    }
    return isAuth;
  }

  public async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isAuth = await this.auth.isAuthenticatedAsync();

    if (!isAuth) {
      const queryParams = state.url === '/home' ? {} : { queryParams: { returnurl: state.url === "/" ? null : state.url } };
      this.route.navigate(['login'], queryParams);
    }
    return isAuth;
  }

  public getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
        .map(v => v.url.map(segment => segment.toString()).join('/'))
        .join('/');
  }
}